<!-- 
<div #broadcastVideo class="game-broadcast-container" [style.width]="(broadcastVideo.offsetHeight*1.95) + 'px'">


        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Srn_YyD-Xr0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div> -->

<div class="video-container">
    <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Srn_YyD-Xr0" frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
</div>